
export const formatSubmissionEmailSenderDate = (date) => {
    const dateToLocale = new Date(date).toLocaleString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'})
    const dateSplit = dateToLocale.split(',')
    const dateArray = dateSplit[0].split('/')
    const month = dateArray[0]
    const day = dateArray[1]
    const year = dateArray[2]
    const time = dateSplit[1]

    switch(window.dateFormat){
      case "YYYY/MM/DD":
        return year + "/" + month + "/" + day + " " + time
      case "MM/DD/YYYY":
        return month + "/" + day + "/" + year + " " + time
      case "DD/MM/YYYY":
        return day + "/" + month + "/" + year + " " + time
      default:
        return month + "/" + day + "/" + year + " " + time
    }
      
    
  }
export const formatDate = date => {
    if (!date) {
        return "";
    }
    const arr = date.split('-');
    return `${arr[1]}/${arr[2]}/${arr[0]}`;
};

export const getCurrentDateAndTime = () => {
    const date = new Date();
    const day = date.getDate().toString();
    const month = (date.getMonth() + 1).toString();
    const year = date.getFullYear().toString();
    const time = date.toLocaleTimeString([], { minute: '2-digit', hour: 'numeric', hour12: true });
    return `${month[1] ? month : `0${month[0]}`}/${day[1] ? day : `0${day[0]}`}/${year} ${time}`;
}

export const getCurrentMonth = () => {
    const months= ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];
    const month = new Date().getMonth();
    return months[month];
};

export const formatCurrency = currency => {
    if (isNaN(currency)) {
        return currency;
    }
    const currencyParts = Math.abs(currency).toFixed(2).split(".");
    return `${currency < 0 ? '$-' : '$'}${currencyParts[0].split("").reverse().reduce((accumulator, current, index) => {
        return `${current}${(index && !(index % 3) ? "," : "")}${accumulator}`;
    }, "")}.${currencyParts[1]}`;
};

export const formatIntCurrency = currency => {
    if (isNaN(currency)) {
        return currency;
    }
    const value = parseInt(currency);
    return `$${formatNumber(value)}`;
};

export const formatNumber = number => {
    if (isNaN(number)) {
        return number;
    }
    return `${number < 0 ? '-' : ''}${Math.abs(number).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
};

export const formatPhoneNumber = number => {
    if (isNaN(number) || number === null) {
        return "";
    }
    const cleaned = number.toString().replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        const intlCode = (match[1] ? `+ ${match[1]}` : '')
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return number;
};

export const formatCurrentPhoneNumber = value => {
    const numValue = value.replace(/\D/g, '');

    if (numValue.length === 0 || numValue.length > 10) return '';

    let areaCodeFormatted = '',
            prefixFormatted = '',
            lineFormatted = '';

    if (numValue.length >= 1 && numValue.length <= 3 ) {
        areaCodeFormatted = `${numValue}`;
    }

    else if (numValue.length >= 4 && numValue.length <= 6 ) {
        areaCodeFormatted = `(${numValue.substring(0,3)})`;
        prefixFormatted = ` ${numValue.substring(3,numValue.length)}`;
    }

    else {
        areaCodeFormatted = `(${numValue.substring(0,3)})`;
        prefixFormatted = ` ${numValue.substring(3,6)}`;
        lineFormatted = `-${numValue.substring(6,numValue.length)}`;
    }

    return `${areaCodeFormatted}${prefixFormatted}${lineFormatted}`;
};

export const formatCreditCardDate = (month, year) => {
    if (month < 10) {
        return `0${month}/${year}`;
    } else {
        return `${month}/${year}`;
    }
};

export const formatCreditCardNumber = number => {
    return `****-****-****-${number}`;
};

export const fetchData = (api, pagination = null, config = null) => {
    let path = window.location.pathname.split('/').filter(item => item !== "");
    path = path.splice(0, path.length - 1);
    if (config) {
        return fetch(`/${path.join('/')}/${api}${pagination ? `?page=${pagination}` : ''}`, config);
    }
    else if (path.length === 0) {
        return fetch(`/${api}${pagination ? `?page=${pagination}` : ''}`);
    }
    else {
        return fetch(`/${path.join('/')}/${api}${pagination ? `?page=${pagination}` : ''}`);
    }
}

export const postData = (api, config) => fetch(api, config);

export const validateEmail = email => {
    const re =  /^[\w\.%+\-\'&]+@(?:[A-Za-z0-9-]+\.)+(?:[A-Za-z0-9-])+$/;
    return re.test(email);
}

export const getToken = () => document.querySelector('[name="csrf-token"]').content
export const formatCapitalizedString = (value) => {
    if (!value) return value;

    const firstLetter = value.charAt(0);

    return `${firstLetter.toUpperCase()}${value.slice(1)}`;
};

export const formatHoursDaysDisplay = (value) => {
    if (value && value < 240) {
        return `${value} Hours`
    } else if (value && value >= 240) {
        return `${Math.round(value / 8)} Business Days`
    } else {
        return null
    }
}
export const formatCurrencyDecimals = (value) => {
    return value.toFixed(2)
}

export const decodeCookieValue = (value = '') => {
    // handle "quoted" RFC 6265 cookie values 
    if (value[0] === '"') {
        value = value.slice(1, -1)
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
}

const encodeCookieName = string => encodeURIComponent(string.replace(/%20/g, ' ')).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape)

// getCookie :: String -> String
export const getCookie = key => decodeCookieValue((document.cookie.match(`(^|; )${encodeCookieName(key)}=([^;]*)`) || 0)[2] || "")

// updateURLParams :: (DomNode, Object) -> IO Effect
export const updateURLParams = (linkNode, newParams) => {
    const url = new URL(linkNode.href)
    const params = new URLSearchParams(url.search)
    for (const [key, value] of Object.entries(newParams)) {
        params.set(key, value)
    }
    url.search = params.toString()
    linkNode.href = url.href
}

export const parseInt = (value) => {
    const num = Number(value)
    return Number.isInteger(num) && num > 0 ? num : null
}

export const cleanParams = (object) => Object.fromEntries(
    Object.entries(object)
        .filter(([key, value]) => value !== null && value !== undefined)
)
